import ReliabilitySDK from 'smarttech-reliability'
import Environment from '../plugins/environment'
import uuidV1 from 'uuid/v1'

const SERVICE_ID = 'content-portal'
const COMPONENT_ID = 'portal'
const UUID = uuidV1()
const METRICS_SERVICE_NAME = 'metrics'

const CP_METRICS_LIST = {
  CONTENT_SEARCH_SUCCESS: 'content-search-success',
  CONTENT_SEARCH_ERROR: 'content-search-errors',
  FETCH_MOST_POPULAR: 'fetch-home-most-popular',
  FETCH_HOME_CATEGORY: 'fetch-home-category',
  FETCH_SEARCH_RESULTS: 'fetch-search-results',
  FETCH_CONTENT_DETAIL: 'fetch-content-detail',
  FETCH_CONTENT_DETAIL_ERROR: 'fetch-content-detail-error',
  FETCH_SHARE_INFO_ERROR: 'fetch-share-info-error',
  FETCH_MODERATED_STATUS_ERROR: 'fetch-moderated-status-error',
  FETCH_MODERATED_METADATA_ERROR: 'fetch-moderated-metadata-error',
  FETCH_MODERATED_METADATA_SUCCESS: 'fetch-moderated-metadata-success',
  FETCH_MODERATED_RESOURCE: 'fetch-moderated-resource',
  FETCH_MODERATED_RESOURCE_ERROR: 'fetch-moderated-resource-error',
  FETCH_MODERATED_RESOURCE_SUCCESS: 'fetch-moderated-resource-success',
  FETCH_DOWNLOAD_URL_ERROR: 'fetch-download-url-error',
  FETCH_DOWNLOAD_URL_SUCCESS: 'fetch-download-url-success',
  DOWNLOAD_RESOURCE_ERROR: 'download-resource-error',
  DOWNLOAD_RESOURCE_SUCCESS: 'download-resource-success',
  CONTENT_PROFILE_ERROR: 'content-profile-error',
  CONTENT_PROFILE_SUCCESS: 'content-profile-success',
  ADD_TO_SLSO: 'add-to-slso',
  DOWNLOAD_RESOURCE: 'download-resource',
  NETWORK_LATENCY: 'network-latency',
  ICON_ERROR: 'display-icon-error',
  UPLOAD_RESOURCE_SUCCESS: 'upload-resource-success',
  UPLOAD_RESOURCE_ERROR: 'upload-resource-error',
  UPDATE_RESOURCE_ERROR: 'update-resource-error',
  UPDATE_RESOURCE_SUCCESS: 'update-resource-success',
  RESOURCE_PROCESSING_SUCCESS: 'resource-processing-success',
  RESOURCE_PROCESSING_ERROR: 'resource-processing-error',
  RESOURCE_EXPIRY_ERROR: 'resource-expiry-error',
  FETCH_ID_STORE_ERROR: 'fetch-id-store-error',
  SAVE_ID_STORE_ERROR: 'save-id-store-error',
  PUT_CONTENT_METADATA_ERROR: 'put-content-metadata-error',
  PUT_CONTENT_METADATA_SUCCESS: 'put-content-metadata-success',
  DELETE_RESOURCE_ERROR: 'delete-resource-error',
  FETCH_MODERATION_QUEUE: 'fetch-moderation-queue',
  FETCH_MODERATION_QUEUE_ERROR: 'fetch-moderation-queue-error',
  FETCH_MODERATION_QUEUE_SUCCESS: 'fetch-moderation-queue-success',
  PUT_MODERATION_STATUS_ERROR: 'put-moderation-status-error',
  PUT_MODERATION_STATUS_SUCCESS: 'put-moderation-status-success',
  INIT_CP_METADATA_ERROR: 'init-cp-metadata-error',
  INIT_CP_METADATA_SUCCESS: 'init-cp-metadata-success',
  FETCH_LOCATION_ERROR: 'fetch-location-error',
  FETCH_LOCATION_SUCCESS: 'fetch-location-success',
  EDGATE_SEARCH_FAILURE: 'edgate-search-failure',
  EDGATE_SEARCH_SUCCESS: 'edgate-search-success',
  UNSUPPORTED_LOCATION: 'unsupported-location'
}

export default {
  CATEGORIES: ReliabilitySDK.enums.SMART_METRIC_CATEGORIES,
  TYPE: ReliabilitySDK.enums.SMART_METRIC_TYPE,
  CP_TAGS: CP_METRICS_LIST,
  initialize: function () {
    let config = {
      environment: Environment.getEnv()
    }
    config.fullUrl = Environment.serviceUrlFor(METRICS_SERVICE_NAME)
    ReliabilitySDK.config.update(config)
  },
  getUUID() {
    return UUID
  },
  getMetricArgs(category, metricLabel, value, type, metadata) {
    if (metadata) {
      metadata.uuid = UUID
      metadata.hostname = Environment.getHostname()
    } else {
      metadata = {
        uuid: UUID,
        hostname: Environment.getHostname()
      }
    }

    let args = {
      serviceId: SERVICE_ID,
      componentId: COMPONENT_ID,
      category: category,
      metric: metricLabel,
      value: value,
      type: type,
      metadata: metadata
    }

    return args
  },
  sendMetric(category, metricLabel, value, type, metadata) {
    let args = this.getMetricArgs(category, metricLabel, value, type, metadata)
    ReliabilitySDK.event.send(args)
  },
  getAsyncTimer(metricLabel) {
    return ReliabilitySDK.utils.startTrackExecutionTimer(
      this.getMetricArgs(this.CATEGORIES.ASYNC_TASKS,
        metricLabel,
        1,
        this.TYPE.TIMER))
  },
  failAsyncTimer(metricLabel, metadata) {
    this.sendMetric(this.CATEGORIES.ASYNC_TASKS,
      metricLabel,
      1,
      this.TYPE.FAILURE_COUNTER,
      metadata)
  }
}
